import { useEffect } from 'react';
import DashboardComponent from './components/App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initializeRUM } from './services/rumService';

function App() {
  useEffect(() => {
    initializeRUM();
  }, []);

  return (
    <ErrorBoundary>
      <DashboardComponent />
    </ErrorBoundary>
  );
}

export default App;
